import React, { memo } from 'react';
import './style.scss';

export default memo(({ children }) => (
    <div className="fm-item-row">
        <span className="fm-item-row__title">{children}</span>
    </div>
));
